import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";

export const styles = (theme: Theme) => {
	return ({
		cardContent: {
			padding: "8px 16px",
			"&:hover .actions": {
				visibility: "visible"
			},
			"& .actions": {
				visibility: "hidden"
			}
		},
		greyCardContent: {
			padding: "8px 16px",
			"&:hover .actions": {
				visibility: "visible",
			},
			"& .actions": {
				visibility: "hidden"
			},
			opacity: .5,
		},
		agentLabel: {
			margin: 10,
		},
		errorText: {
			marginTop: 2,
			whiteSpace: "nowrap",
		},
	} satisfies Record<string, CSSObject>)
};
